<div class="container">
  <ng-container *ngIf="applicationService.company()">
    <div *ngIf="purchaseLocation === ''">

      <h3>WHERE DID YOU PURCHASE THE BAT?</h3>
      <button mat-raised-button (click)="onSite(true)" type="button">
        I purchased the bat at a {{ companySite().site }} website.
      </button>
      <button mat-raised-button (click)="onSite(false)" type="button">
        I did NOT purchase the bat at a {{ companySite().site }} website.
      </button>
    </div>
  </ng-container>
  <div class="grow"></div>
</div>
